<!-- Header -->
<div class="page-heading">
  <div class="page-heading-blue row p-4">
    <div class="col-6">
      <ng-container *ngIf="channel">
        <div>
          <div class="montserrat">{{'PROGRAM' | translate}}&nbsp;<i
              class="fal fa-angle-right fa-lg"></i>&nbsp;{{channel?.program?.name}}&nbsp;<i
              class="fal fa-angle-right fa-lg"></i>&nbsp;{{'CHANNEL' | translate}}&nbsp;<i
              class="fal fa-angle-right fa-lg"></i>
          </div>
          <div class="montserrat">
            <h2>{{ channel.name }}</h2>
          </div>
          <div class="header-timestamp">
            <span>{{ 'VERSION' | translate}}: </span>
            <b>{{ channel.version }}</b>
            <span class="ml-3">{{ 'LAST-SAVED' | translate}}: </span>
            <b>{{ channel.lastModifiedOn | date:'medium' }}</b>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-4 my-auto" *ngIf="channel">
      {{ channel.description }}
    </div>
    <div class="col-2 my-auto">
      <div class="mt-2 text-right">
        <button appPreventClick *ngIf="channel?.status !== null && channel?.status !== 'Template'"
          [disabled]="deployingProcess" class="btn btn-outline-light" (click)="deployProcess()">
          {{ 'DEPLOY-PROCESS' | translate }}
        </button>
      </div>
      <div class="mt-2 text-right mb-1">
        <button class="btn btn-outline-light" (click)="backToChannelEdit()">
          {{ 'BACK-TO-CHANNEL-EDIT' | translate }}
          <i class="arrow fal fa-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loading" class="text-center">
  <span class="k-icon k-i-loading kendo-loading-icon"></span>
</div>

<div class="iframe-container">
  <iframe [src]="url" (load)="manageLoad()" frameborder="0" #iframeModeler></iframe>
</div>